import React, { FunctionComponent } from 'react';
import Translate from 'ui/atoms/translate';
import { Modal, ModalHeader, ModalContent, ModalFooter, ModalFooterButtons } from 'ui/molecules/modal';
import Hint from 'src/ui/atoms/hint';

interface DeleteApiConnectionSuccessModalProps {
  onClose: () => void;
}

const DeleteApiConnectionSuccessModal: FunctionComponent<DeleteApiConnectionSuccessModalProps> = ({ onClose }) => {
  return (
    <Modal onClose={onClose}>
      <ModalHeader>
        <Translate name={'deleteApiConnectionSuccessModal.title'} />
      </ModalHeader>
      <ModalContent>
        <Hint variant="success">
          <Translate name="deleteApiConnectionSuccessModal.hint" />
        </Hint>
      </ModalContent>
      <ModalFooter>
        <ModalFooterButtons
          actionButtons={[
            {
              name: 'close',
              content: <Translate name="common.close" />,
              size: 'large',
              onClick: () => onClose(),
            },
          ]}
        />
      </ModalFooter>
    </Modal>
  );
};

export default DeleteApiConnectionSuccessModal;
